export default __webpack_public_path__ + "static/media/step-03.d7c90d91.png";